import React from 'react';
import './renunganDetailModal.scss'; 

const RenunganDetailModal = ({ renungan, onClose }) => {
    // Jika tidak ada data renungan (modal tertutup), kembalikan null
    if (!renungan) return null; 

    return (
        // Gunakan class 'modal-overlay' yang kini memiliki 'overflow-y: auto' di SCSS
        <div 
            className="modal-overlay active" 
            onClick={onClose} 
        >
            {/* Konten Modal */}
            <div 
                className="modal-content" // Class untuk kotak konten modal
                onClick={(e) => e.stopPropagation()} // Mencegah klik di dalam modal menutupnya
            >
                {/* Tombol Tutup - Diposisikan ABSOLUTE/FIXED di SCSS */}
                <button 
                    onClick={onClose} 
                    className="close-button" // Class untuk tombol tutup
                >
                    &times;
                </button>
                
                {/* Konten Renungan */}
                <div className="modal-body">
                    {/* Judul dan Info Penulis */}
                    <div className="modal-header">
                        <h2>{renungan.judul}</h2>
                        <p>
                            Penulis: {renungan.penulis} | Tanggal: {renungan.tanggal} | Pembacaan: {renungan.alkitab}
                        </p>
                    </div>

                    {/* Konten Utama */}
                    <div 
                        className="renungan-content"
                        dangerouslySetInnerHTML={{ __html: renungan.konten }} 
                    />
                </div>
            </div>
        </div>
    );
};

export default RenunganDetailModal;